module.exports = __webpack_public_path__ + "media/images/landing/flags/ru-0cacf46e6f473fa88781120f370d6107.svg";